import { createFileRoute } from "@tanstack/react-router";
import AdminCurriculumDetailPage from "@/pages/admin/lms/curricula/detail";
import { useLmsPermissions } from "@/pages/admin/lms";

export const Route = createFileRoute("/app/admin/lms/curricula/$curriculumId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { curriculumId } = Route.useParams();
  const {
    userCanAssociateMaterialsAndCriteria,
    userCanAssociateMaterialsAndTags,
    userCanAssociateMaterialsAndUserFunctions,
    userCanEditAllMaterials,
    userCanViewAllCriteria,
    userCanViewAllMaterials,
    userCanViewAllSettingTags,
    userCanViewAllTags,
  } = useLmsPermissions();

  return (
    <AdminCurriculumDetailPage
      id={Number(curriculumId)}
      userCanAssociateMaterialsAndCriteria={userCanAssociateMaterialsAndCriteria}
      userCanAssociateMaterialsAndTags={userCanAssociateMaterialsAndTags}
      userCanAssociateMaterialsAndUserFunctions={userCanAssociateMaterialsAndUserFunctions}
      userCanEditAllMaterials={userCanEditAllMaterials}
      userCanViewAllCriteria={userCanViewAllCriteria}
      userCanViewAllMaterials={userCanViewAllMaterials}
      userCanViewAllSettingTags={userCanViewAllSettingTags}
      userCanViewAllTags={userCanViewAllTags}
    />
  );
}
